{
  "title": "Circle of Death",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level necromancy",
  "level": 6,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (the powder of a crushed black pearl worth at least 500 gp)",
  "duration": "Instantaneous",
  "description": [
    "A sphere of negative energy ripples out in a 60-foot-radius sphere from a point within range. Each creature in that area must make a Constitution saving throw. A target takes 8d6 necrotic damage on a failed save, or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, the damage increases by 2d6 for each slot level above 6th."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
